// extracted by mini-css-extract-plugin
export var content = "_a0-3";
export var list = "_a0-4";
export var settingsContent = "_a0-7";
export var settingsPanel = "_a0-8";
export var state = "_a0-6";
export var triggerBadge = "_a0-2";
export var triggerButton = "_a0-1";
export var triggerShell = "_a0-0";
export var unreadDot = "_a0-5";